import type { Bank, BankAccount } from "../../types";

/**
 * Flattens the nested `Bank[] → BankAccount[]` shape returned by
 * `useProjectDataQuery` into a single, lookup-friendly `BankAccount[]` keyed by
 * id. Each account is enriched with its parent bank's name + logo so the
 * preview mapper can build the store's `projectBankAccounts` entries.
 */
export function flattenBanks(banks: Bank[] | undefined | null): BankAccount[] {
  if (!banks?.length) return [];
  return banks.flatMap((b) =>
    (b.bankAccounts ?? []).map((a) => ({
      ...a,
      bankName: b.name,
      bankImageFullUrl: b.imageFullUrl,
    })),
  );
}
